// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoText_root__3R0Mm"};